import { render, staticRenderFns } from "./CardResourceCounter.vue?vue&type=template&id=5e0b13a6"
import script from "./CardResourceCounter.vue?vue&type=script&lang=ts"
export * from "./CardResourceCounter.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports